module.exports = __webpack_public_path__ + "img/tankertruck.7ac608ec.svg";